module.exports = __webpack_public_path__ + "static/media/centrichealth.16dcb87d.png";